import { type EmployeeInfo } from './types';

// per https://i.amazon.com/V1920237414 PAPI doesn't always return business title but jobProfile does seem to return
// consistently
export const getJobTitle = ({ basicInfo }: EmployeeInfo) => {
  const businessTitle = basicInfo.businessTitle?.trim();
  if ((businessTitle?.length ?? 0) > 0) {
    return businessTitle;
  }

  return basicInfo.jobProfileName?.trim();
};
